import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, interval } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { format } from 'date-fns';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import * as ExcelJS from 'exceljs';

@Component({
  selector: 'app-relatorio-interplantas-preenchido',
  templateUrl: './relatorio-interplantas-preenchido.component.html',
  styleUrls: ['./relatorio-interplantas-preenchido.component.css'],
  standalone: false
})
export class RelatorioInterplantasPreenchidoComponent {

  item: any = {};
  items: any[] = [];
  filtereditems: any[] = [];
  usuarios: any[] = [];
  carriers: any[] = [];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlNotify: string = 'https://29o5gcw81i.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'relatorioPreenchidoInterplantas';
  queryUsers: string = 'usersPortal';
  queryCarriers: string = 'Carriers';
  querylocation: string = 'Fornecedores_Karrara_Transport';
  queryVehicles: string = 'tipos_Veiculos_Karrara';
  comentario: string = "";
  $even: any;
  $odd: any;
  dataSource: any;
  itemsCarrier: any[] = [];
  itemsCompletos: any[] = [];
  searchString: string = '';
  itemsOrigin: any[] | undefined;
  placesOrigin: any[] | undefined;
  usuarioLogado!: UsuarioLogado;
  currentDate = new Date();
  existingExcelFile: string = 'C:/Users/ssbuif/Desktop/Transport Instruction-teste.xlsx';
  locais!: any[];
  typesVehicles: any[] = [];
  typesCarriers: string[] = [
    'LOTS',
    'SESÉ',
    'SESÉ CRÍTICO'
  ];
  dialogOpen!: boolean;
  formBuilder: any;
  formGroup: any;
  selectedValue = 0;
  contactCarrier: string = '';
  contactTrasport: string = '+5511974882943';
  status: string = 'Requested';
  dataNotify: any;
  isCarrierEnabled: boolean = false;
  campoTocado: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  isLoading: boolean = true;
  isUserEnabled: boolean = false;
  isAdminEnabled: boolean = false;
  locationDeliveryChanged!: boolean;
  locationPickupChanged!: boolean;
  subscription: Subscription | undefined;
  // endDate: string | number | Date;
  endDate: Date = new Date();
  startDate: Date = new Date();
  endDateIni: Date = new Date();
  startDateIni: Date = new Date();
  startDateFilter!: Date;// Data de início do intervalo selecionado
  endDateFilter!: Date; // Data de término do intervalo selecionado
  dateInicial = new Date('1970-01-02')


  @ViewChild('dateInput') dateInput: any;
  @ViewChild('dateInput2') dateInput2: any;
  allItems: any[] = [];
  contatoColeta!: string;
  telefoneColeta!: string;
  contatoEntrega!: string;
  telefoneEntrega!: string;


  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private autenticacaoService: AutenticacaoService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    await this.getUsers()
    await this.getUserLogado()
    await this.getCarriers()
    await this.enableFields();
    await this.getVehiclesType();
    await this.upDate();
    // await this.upDate()
    // //console.log(this.items)
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.upDate();
      await this.enableFields();
    });

  }

  async upDate() {
    await this.getItemsFromDynamoDB();
    await this.getItemsFromOrigin();
  }

  onFieldTouched() {
    this.campoTocado = true;
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    } else if (this.usuarioLogado.role == '1' || this.usuarioLogado.role == '6' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' || this.usuarioLogado.role == '8') {
    // } else if (this.usuarioLogado.role == '1') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    }
  }

  editDialog(item: any): void {
    this.campoTocado = false;
    this.enableFields();
    //console.log(item.ID)
    this.item.ID = item.ID;
    //console.log(item);
    this.item.date = item.date;
    this.item.plannedArrival = item.plannedArrival;
    this.item.timeplannedArrival = item.timeplannedArrival;
    this.item.tripIdent = item.tripIdent;
    this.item.linha = item.linha;
    this.item.carrier = item.carrier;
    this.item.vehicle = item.vehicle;
    this.item.plate = item.plate;
    this.item.motorista = item.motorista;
    this.item.path = item.path;
    this.item.weight = parseFloat(item.weight);
    this.item.distance = parseFloat(item.distance);
    // this.item.CO2e = parseFloat(item.CO2e);
    this.item.notaFiscal = item.notaFiscal;
    this.item.CTESese = item.CTESese;
    this.item.valorFrete = item.valorFrete;
    this.item.fornecedor = item.fornecedor;

    this.dialogOpen = true;

  }

  onFieldChanged(fieldName: string, newValue: string) {
    // O código a ser executado quando o campo for alterado
    if (fieldName == 'locationDelivery') {
      if (newValue == 'other') {
        this.item.addressDelivery = null
        this.item.cityDelivery = null
        this.item.stateDelivery = null
      } else {
        this.item.addressDelivery = this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco ? this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco : this.item.addressPickup
      }
    } else if (fieldName == 'locationPickup') {
      if (newValue == 'other') {
        this.item.addressPickup = null
        this.item.cityPickup = null
        this.item.statePickup = null
      } else {
        this.item.addressPickup = this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco ? this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco : this.item.addressPickup
      }
    }
    //console.log(`Campo '${fieldName}' alterado para '${newValue}'`);
  }

  onFieldChanged2(fieldName: string, newValue: string) {
    // O código a ser executado quando o campo for alterado
    //console.log(newValue)
    if (fieldName == 'carrier') {
      if (newValue == 'LOTS') {
        this.item.weight = 25000;
        // this.item.CO2e = (this.item.distance * 2.86) / 2.82
      }
      else if (newValue == 'SESÉ') {
        this.item.weight = 8800;
        // this.item.CO2e = (this.item.distance * 2.86) / 2.82
      }
      else if (newValue == 'SESÉ CRÍTICO') {
        this.item.weight = 500;
        // this.item.CO2e = (this.item.distance * 2.86) / 2.82
      }
    } else if (fieldName == 'vehicle') {
      this.item.consumo = this.typesVehicles.find(veic => veic.modelo == newValue).consumo
      this.item.emissao = this.typesVehicles.find(veic => veic.modelo == newValue).emissoes
    }
    // //console.log(`Campo '${fieldName}' alterado para '${newValue}'`);
    // //console.log('consumo = ' + this.item.consumo);
    // //console.log('emissao = ' + this.item.emissao);    
    // if (this.item.distance && this.item.emissao && this.item.consumo) {
    //   this.item.CO2e = (this.item.distance * this.item.emissao) / this.item.consumo
    // }    
    // //console.log('CO2e = ' + this.item.CO2e);
  }

  calculoEmissao(item: any) {
    this.item.consumo = this.typesVehicles.find(veic => veic.modelo == item.vehicle).consumo
    this.item.emissao = this.typesVehicles.find(veic => veic.modelo == item.vehicle).emissoes

    //console.log('consumo = ' + this.item.consumo);
    //console.log('emissao = ' + this.item.emissao);
    if (this.item.distance && this.item.emissao && this.item.consumo) {
      // this.item.CO2e = (this.item.distance * this.item.emissao) / this.item.consumo
      this.item.emissaoTotal = (this.item.distance * this.item.emissao) / item.consumo;
      // this.item.COKPI = this.item.CO2e / this.item.weight
    }
    // //console.log('CO2e = ' + this.item.CO2e);
    // //console.log('CO2e KPI = ' + this.item.COKPI);
    // //console.log(item)
  }

  //distância x emissao / consumo. 

  solicitarFrete() {
    this.item = {};
    // this.item.reqName = this.usuarioLogado.nome;
    // this.item.reqId = this.usuarioLogado.id;
    this.item.ID = format(new Date(), 'ddMMyyyyHHmmss');
    // Remova todos os caracteres não numéricos (exceto dígitos)
    const numerosString = this.item.ID.replace(/\D/g, '');

    // Converta a string numérica para um número
    this.item.ID = parseInt(numerosString, 10);
    this.item.distance = 16.65;
    // this.item.status = 'New request';
    this.item.date = new Date();
    //console.log(this.item.date)
    this.dialogOpen = true;
  }

  async salvar(item: any) {
    this.isLoading = true;
    // //console.log(this.item.fornecedor)
    // //console.log(this.item.ID)
    await this.calculoEmissao(item);

    try {

      // if (
      //   this.item.reqEmail &&
      //   this.item.reqId &&
      //   this.item.reqName &&
      //   this.item.reqPhone &&
      //   this.item.costCenter &&
      //   this.item.locationPickup &&
      //   this.item.datePickup &&
      //   this.item.timePickup &&
      //   this.item.locationDelivery &&
      //   this.item.dateDelivery &&
      //   this.item.timeDelivery &&
      //   this.item.tipo
      // ) {
      this.item = {
        "ID": this.item.ID,
        "date": this.item.date,
        "plannedArrival": this.item.plannedArrival,
        "timeplannedArrival": this.item.timeplannedArrival,
        "tripIdent": this.item.tripIdent,
        "linha": this.item.linha,
        "carrier": this.item.carrier,
        "Transport Type": this.item.vehicle,
        "Plate": this.item.plate,
        "motorista": this.item.motorista,
        "path": this.item.path,
        "Weight Loaded": this.item.weight,
        "Total Distance": this.item.distance,
        "CO2e": this.item.CO2e,
        "consumo": this.item.consumo,
        "emissao": this.item.emissao,
        "emissaoTotal": this.item.emissaoTotal,
        // "COKPI": this.item.COKPI,
        "notaFiscal": this.item.notaFiscal,
        "CTESese": this.item.CTESese,
        "valorFrete": this.item.valorFrete,
        "Fornecedor 1": this.item.fornecedor ? this.item.fornecedor : 'LCB',
        "Volumes": 0,
        "Cubage": 0,
        "Total Cost": 0
      }
      this.item.tableName = this.query
      // Remover as barras invertidas escapadas
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      //console.log(modifiedJsonString);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
        await this.upDate();
        // this.cdr.detectChanges();
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {

        console.log(error);
      });
    } catch (error) {
      const confirmacao = window.confirm("Por favor, revise o preenchimento do formulario!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = false;
        console.error('Error :', error);
      }
    }
  }

  clearFilter() {
    // this.allItems = this.items;
    this.allItems = this.items.sort((a, b) => {
      if (typeof a.date === 'string' && typeof b.date === 'string') {
        return b.date.localeCompare(a.date);
      } else {
        // Lógica para lidar com outros tipos ou tratar como números
        return b.date - a.date;
      }
    });
    this.dateInput.nativeElement.value = '';
    this.dateInput2.nativeElement.value = '';
    this.startDateFilter = this.dateInicial
    this.endDateFilter = this.dateInicial
    //console.log(this.startDateFilter)
  }

  async applyFilter() {
    //console.log("entrou no filtro")
    //console.log(this.startDateFilter)
    //console.log(this.endDateFilter)

    if (this.startDateFilter && this.endDateFilter) {
      this.startDate = new Date(this.startDateFilter); // Certifique-se de que this.startDate seja um valor válido no formato de data
      this.startDate.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos para zero
      this.startDate.setDate(this.startDate.getDate() + 1); // Acrescenta um dia
      //console.log(this.startDate)

      this.endDate = new Date(this.endDateFilter);
      this.endDate.setHours(0, 0, 0, 0);
      this.endDate.setDate(this.endDate.getDate() + 1); // Acrescenta um dia
      //console.log(this.endDate)


      this.allItems = await this.items.filter(item => {
        const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
        itemDate.setHours(0, 0, 0, 0);
        return itemDate >= this.startDate && itemDate <= this.endDate;
      });
      this.allItems = this.allItems.sort((a, b) => {
        if (typeof a.date === 'string' && typeof b.date === 'string') {
          return b.date.localeCompare(a.date);
        } else {
          // Lógica para lidar com outros tipos ou tratar como números
          return b.date - a.date;
        }
      });
    } else {
      //console.log("else filtro")
      // this.allItems = this.items;
      this.allItems = this.items.sort((a, b) => {
        if (typeof a.date === 'string' && typeof b.date === 'string') {
          return b.date.localeCompare(a.date);
        } else {
          // Lógica para lidar com outros tipos ou tratar como números
          return b.date - a.date;
        }
      });
      //console.log(this.items)
      //console.log(this.filtereditems)

    }
  }

  async aplicarFiltro() {
    //console.log("filtro blur")
    //console.log(this.searchString)
    if (!this.searchString) {
      //console.log("tem search string")

      if (this.startDateFilter && this.endDateFilter && this.startDateFilter != this.dateInicial && this.endDateFilter != this.dateInicial) {
        //console.log("tem start date")

        this.allItems = await this.items.filter(item => {
          const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
          itemDate.setHours(0, 0, 0, 0);
          return itemDate >= this.startDate && itemDate <= this.endDate;
        });
        this.allItems = this.allItems.sort((a, b) => {
          if (typeof a.date === 'string' && typeof b.date === 'string') {
            return b.date.localeCompare(a.date);
          } else {
            // Lógica para lidar com outros tipos ou tratar como números
            return b.date - a.date;
          }
        });
      } else {
        //console.log("NAO tem start date")

        // this.allItems = this.items;
        this.allItems = this.items.sort((a, b) => {
          if (typeof a.date === 'string' && typeof b.date === 'string') {
            return b.date.localeCompare(a.date);
          } else {
            // Lógica para lidar com outros tipos ou tratar como números
            return b.date - a.date;
          }
        });
      }
    }
    //console.log("NAO tem search string")
    this.allItems = this.allItems.filter(item => this.filtrarItem(item));
    this.allItems = this.allItems.sort((a, b) => {
      if (typeof a.date === 'string' && typeof b.date === 'string') {
        return b.date.localeCompare(a.date);
      } else {
        // Lógica para lidar com outros tipos ou tratar como números
        return b.date - a.date;
      }
    });
  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    if (!this.searchString) {
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }
    const lowerCaseFilter = this.searchString.toLowerCase();
    // Verificar se alguma propriedade do item corresponde ao filtro (ignorando maiúsculas e minúsculas)
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }
    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  }

  async getCarriers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryCarriers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.carriers')
          // //console.log((this.carriers))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getVehiclesType(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryVehicles, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.typesVehicles = items.map(item => ({ ...item, checked: false }));
              // //console.log(this.typesVehicles)
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.carriers')
          // //console.log((this.carriers))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getUsers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryUsers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.usuarios = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.usuarios')
          // //console.log((this.usuarios))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  verificaContato(newValue: string) {
    // //console.log("entrou no verifica")
    // //console.log(newValue)
    this.item.contatoPickup = this.locais.find(item => item.local == newValue).nomeContato
    this.item.telefonePickup = this.locais.find(item => item.local == newValue).telefone
    // //console.log(this.contatoColeta)
  }

  verificaContatoEntrega(newValue: string) {
    // //console.log("entrou no verifica")
    // //console.log(newValue)
    this.item.contatoDelivery = this.locais.find(item => item.local == newValue).nomeContato
    this.item.telefoneDelivery = this.locais.find(item => item.local == newValue).telefone
    // //console.log(this.contatoColeta)
  }

  cancel(): void {
    this.campoTocado = false;
    this.dialogOpen = false;
    this.locationDeliveryChanged = false;
    this.locationPickupChanged = false;
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // //console.log(this.usuarioLogado)
  }

  async getItemsFromOrigin(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.querylocation, this.urlConsulta, filtro)).subscribe(
      async (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.itemsOrigin = items.map(item => ({ ...item, checked: false }));

              // Ordena os itens em ordem alfabética com base na propriedade 'local'
              await this.itemsOrigin.sort((a, b) => a.local.localeCompare(b.local));

              // Salva os locais ordenados em this.placesOrigin
              this.placesOrigin = this.itemsOrigin.map(item => item.local);
              this.locais = items;
              // //console.log(this.placesOrigin)
              // //console.log(items)
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getItemsFromDynamoDB(): Promise<void> {
    const filtro = 'All';
    (await this.dynamodbService.getItems(this.query, this.urlConsulta, filtro)).subscribe(
      async (response: any) => {
        // //console.log(response)
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            // this.allItems = items;         
            // //console.log(items)
            if (Array.isArray(items)) {
              this.allItems = items.sort((a, b) => {
                if (typeof a.date === 'string' && typeof b.date === 'string') {
                  return b.date.localeCompare(a.date);
                } else {
                  // Lógica para lidar com outros tipos ou tratar como números
                  return b.date - a.date;
                }
              });
              this.items = items.map(item => ({ ...item, checked: false }));           
              this.cdr.detectChanges();
              this.isLoading = false;
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async deleteItem(ID: string, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
        async response => {
          // setTimeout(() => {
          await this.getItemsFromDynamoDB();
          this.isLoading = false;

          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  async exportToExcel(data: any[]): Promise<void> {
    //console.log(data);
    if (data.length === 0) {
      //console.log('Nenhum dado para exportar.');
      return;
    }

    const columnOrder = [
      'ID',
      'date',
      'plannedArrival',
      'tripIdent',
      'linha',
      'carrier',
      'vehicle',
      'plate',
      'motorista',
      'path',
      'weight',
      'distance',
      'CO2e',
      'notaFiscal',
      'CTESese',
      'valorFrete',
      'fornecedor'
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Adicione o cabeçalho à planilha e aplique formatação
    const headerRow = worksheet.addRow(columnOrder);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'C0C0C0' }
    };

    // Adicione bordas ao cabeçalho
    headerRow.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Adicione os dados às linhas da planilha
    data.forEach(item => {
      const row = columnOrder.map(column => item[column]);
      const dataRow = worksheet.addRow(row);
      // Adicione bordas aos dados
      dataRow.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Salve o arquivo modificado
    const outputFilePath = 'relatório_interplantas.xlsx';
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo modificado');
  }


  // async addImageToExcel(item: any): Promise<void> {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');

  //   const imageSrc = 'assets/SCANIA.png';
  //   const response = await fetch(imageSrc);
  //   const buffer2 = await response.arrayBuffer();
  //   let logo = workbook.addImage({
  //     buffer: buffer2,
  //     extension: 'jpeg',
  //   });
  //   worksheet.addImage(logo, 'B2:C4');

  //   const imageSrc2 = 'assets/Griffo.png';
  //   const response2 = await fetch(imageSrc2);
  //   const buffer3 = await response2.arrayBuffer();
  //   let logo2 = workbook.addImage({
  //     buffer: buffer3,
  //     extension: 'jpeg',
  //   });
  //   worksheet.addImage(logo2, 'K2:L4');

  //   // Defina um objeto com as posições das células e os valores correspondentes
  //   const cellData = [
  //     { position: 'B3:N3', value: 'ID: ' + item.ID, isRightAligned: true },
  //     { position: 'B4:N4', value: 'INSTRUÇÃO DE TRANSPORTE', isBold: true, isCentered: true, backgroundColor: 'FFFACD', border: true },
  //     { position: 'B6:L6', value: 'LCB - Rua dos Feltrins, 843 - B. Demarchi - SBC - SP', isBold: true, isCentered: true },
  //     { position: 'B7:L7', value: 'LPC - Rua Comendador João Lucas Vinhedo, 580 - Vinhedo - SP', isBold: true, isCentered: true },
  //     { position: 'B8:L8', value: 'SLA - Av. José Odorizzi, 151 - São Bernardo - SP', isBold: true, isCentered: true },
  //     { position: 'M5:N5', value: 'Nº da N.Fiscal' },
  //     { position: 'M6:N7', value: item.nf, isCentered: true, isBold: true },
  //     { position: 'M8:N8', value: 'Valor da N.Fiscal' },
  //     { position: 'M9:N12', value: item.nfTotal, isCentered: true, isBold: true },
  //     { position: 'B11:C12', value: 'IMPORTANTE:', isBold: true, color: 'FF0000', isCentered: true },
  //     { position: 'D11:L11', value: '- Para entrega é obrigatório o preenchimento do número e valor da N. Fiscal', color: 'FF0000', isBold: true },
  //     { position: 'D12:L12', value: '- O endereço constante da NF deve ser o mesmo do destino da mercadoria', color: 'FF0000', isBold: true },
  //     { position: 'B13:N13', value: 'DADOS PARA LOCALIZAÇÃO DA RETIRADA', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
  //     { position: 'B14:I14', value: 'Fornecedor / Cliente:' },
  //     { position: 'B15:I15', value: item.locationPickup == "other" ? item.otherLocationPickup : item.locationPickup + (item.areaPickup ? " - " + item.areaPickup : ""), isBold: true },
  //     { position: 'J14:L14', value: 'Nome para contato:' },
  //     { position: 'J15:L15', value: item.contatoPickup, isBold: true },
  //     { position: 'M14:N14', value: 'Tel. contato:' },
  //     { position: 'M15:N15', value: item.telefonePickup, isBold: true },
  //     { position: 'B16:I16', value: 'Descrição do Material:' },
  //     { position: 'B17:I17', value: item.description, isBold: true },
  //     { position: 'J16:L16', value: 'Peso Bruto:' },
  //     { position: 'J17:L17', value: item.weight, isBold: true },
  //     { position: 'M16:N16', value: 'Quantidade:' },
  //     { position: 'M17:N17', value: item.quantity, isBold: true },
  //     { position: 'B18:N18', value: 'Endereço: ' },
  //     { position: 'B19:N19', value: item.addressPickup, isBold: true },//(this.locais.find(end => end.local == this.item.locationPickup).endereco ? this.locais.find(end => end.local == this.item.locationPickup).endereco : " falta cadastro ") , isBold: true }, //item.addressPickup, isBold: true },
  //     { position: 'B20:D20', value: 'Cidade: ' },
  //     { position: 'B21:D21', value: item.cityPickup, isBold: true },
  //     { position: 'E20:H20', value: 'Estado: ' },
  //     { position: 'E21:H21', value: item.statePickup, isBold: true },
  //     { position: 'I20:L20', value: 'Data da retirada: ' },
  //     { position: 'I21:L21', value: item.datePickup, isBold: true },
  //     { position: 'M20:N20', value: 'Horário: ' },
  //     { position: 'M21:N21', value: item.timePickup, isBold: true },
  //     { position: 'B22:N22', value: 'Motivo: ' },
  //     { position: 'B23:N24', value: item.motive, isCentered: true, isBold: true },
  //     { position: 'B25:N25', value: 'DADOS PARA LOCALIZAÇÃO DA ENTREGA', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
  //     { position: 'B26:I26', value: 'Fornecedor / Cliente: ' },
  //     { position: 'B27:I27', value: item.locationDelivery == "other" ? item.otherLocationDelivery : item.locationDelivery + (item.areaPickup ? " - " + item.areaPickup : ""), isBold: true },
  //     { position: 'J26:L26', value: 'Nome para contato:' },
  //     { position: 'J27:L27', value: item.contatoDelivery, isBold: true },
  //     { position: 'M26:N26', value: 'Tel. contato:' },
  //     { position: 'M27:N27', value: item.telefoneDelivery, isBold: true },
  //     { position: 'B28:N28', value: 'Endereço: ' },
  //     { position: 'B29:N29', value: item.addressDelivery, isBold: true }, // (this.locais.find(end => end.local == this.item.locationDelivery).endereco ? this.locais.find(end => end.local == this.item.locationDelivery).endereco : ""), isBold: true }, //item.addressDelivery, isBold: true },
  //     { position: 'B30:D30', value: 'Cidade: ' },
  //     { position: 'B31:D31', value: item.cityDelivery, isBold: true },
  //     { position: 'E30:H30', value: 'Estado: ' },
  //     { position: 'E31:H31', value: item.stateDelivery, isBold: true },
  //     { position: 'I30:J30', value: 'Data da retirada: ' },
  //     { position: 'I31:J31', value: item.dateDelivery, isBold: true },
  //     { position: 'K30:N30', value: 'Horário: ' },
  //     { position: 'K31:N31', value: item.timeDelivery, isBold: true },
  //     { position: 'B32:N32', value: 'Observações: ' },
  //     { position: 'B33:N34', value: item.notes, isCentered: true, isBold: true },
  //     { position: 'B35:N35', value: 'TIPO DE VEÍCULO A SER UTILIZADO', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
  //     { position: 'B36:N40', value: item.vehicleType + " - " + item.plate, isCentered: true, isBold: true },
  //     { position: 'B41:N41', value: 'PREENCHIMENTO OBRIGATÓRIO', isBold: true, isCentered: true, backgroundColor: 'FFFACD', color: 'FF0000' },
  //     { position: 'B42:E42', value: 'Solicitante: ', color: 'FF0000' },
  //     { position: 'B43:E43', value: item.reqName, color: 'FF0000', isBold: true },
  //     { position: 'F42:H42', value: 'Telefone: ', color: 'FF0000' },
  //     { position: 'F43:H43', value: item.reqPhone, color: 'FF0000', isBold: true },
  //     { position: 'I42:N42', value: 'Centro de custo: ', color: 'FF0000' },
  //     { position: 'I43:N43', value: item.costCenter, color: 'FF0000', isBold: true },
  //     { position: 'B44:C44', value: 'Cod. Sub.: ', color: 'FF0000' },
  //     { position: 'B45:C45', value: ' ', color: 'FF0000', isBold: true },
  //     { position: 'D44:J44', value: 'Tipo Material: ', color: 'FF0000' },
  //     { position: 'D45:J45', value: item.tipo, color: 'FF0000', isBold: true },
  //     { position: 'K44:N44', value: 'Pedido de compra: ', color: 'FF0000' },
  //     { position: 'K45:N45', value: item.projectNumber, color: 'FF0000', isBold: true },
  //     { position: 'B5:L5', backgroundColor: 'F5FFFA' },
  //     { position: 'B9:L10', backgroundColor: 'F5FFFA' },
  //     { position: 'B0:N2', backgroundColor: 'F5FFFA' },


  //   ];

  //   // Percorra o objeto cellData e adicione os valores às células
  //   for (const data of cellData) {
  //     const cellRange = data.position;
  //     const valueToFill = data.value;

  //     // Decodifique a posição da célula de início do intervalo
  //     const { c: startCol, r: startRow } = XLSX.utils.decode_cell(cellRange.split(':')[0]);

  //     // Decodifique a posição da célula final do intervalo
  //     const { c: endCol, r: endRow } = XLSX.utils.decode_cell(cellRange.split(':')[1]);

  //     // Mesclar as células no intervalo
  //     worksheet.mergeCells(startRow + 3, startCol, endRow + 3, endCol);

  //     // Definir o valor da célula mesclada
  //     // worksheet.getCell(startRow, startCol).value = valueToFill;

  //     // Definir o valor da célula mesclada
  //     const cell = worksheet.getCell(startRow + 3, startCol);
  //     cell.value = valueToFill;

  //     // Adicionar bordas às células            
  //     // Configurar bordas se a propriedade border for true
  //     if (data.border) {
  //       cell.border = {
  //         top: { style: 'thin' },
  //         left: { style: 'thin' },
  //         bottom: { style: 'thin' },
  //         right: { style: 'thin' }
  //       };
  //     } else {
  //       cell.border = {
  //         top: { style: 'thin' },
  //         left: { style: 'thin' },
  //         bottom: { style: 'thin' },
  //         right: { style: 'thin' }
  //       };
  //     }

  //     // Aplicar negrito se a propriedade isBold for true
  //     if (data.isBold) {
  //       cell.font = { bold: true };
  //     }

  //     // Definir a cor do texto se a propriedade color estiver definida
  //     if (data.color) {
  //       cell.font = cell.font || {};
  //       cell.font.color = { argb: data.color };
  //     }

  //     // Centralizar o conteúdo horizontalmente e verticalmente
  //     if (data.isCentered) {
  //       cell.alignment = { horizontal: 'center', vertical: 'middle' };
  //     }

  //     // Alinhar o conteúdo à direita se a propriedade isRightAligned for true
  //     if (data.isRightAligned) {
  //       cell.alignment = { horizontal: 'right' };
  //     }

  //     // Definir a cor de fundo se a propriedade backgroundColor estiver definida
  //     if (data.backgroundColor) {
  //       cell.fill = {
  //         type: 'pattern',
  //         pattern: 'solid',
  //         fgColor: { argb: data.backgroundColor }
  //       };
  //     } else {
  //       cell.fill = {
  //         type: 'pattern',
  //         pattern: 'solid',
  //         fgColor: { argb: 'F5FFFA' }
  //       };
  //     }
  //   }
  //   // Salve o arquivo modificado
  //   const outputFilePath = 'Instrucao de transporte' + item.ID + '.xlsx';
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //   fs.saveAs(blobData, outputFilePath);

  //   // Exiba um alerta para o usuário baixar o arquivo
  //   alert('Clique para baixar o arquivo modificado');
  // }

}